import { createHook, createStore } from 'react-sweet-state';

import { fetchProgressForCourses } from 'src/store/progress/actions/courseProgressActions';
import { ContentfulSmCourse } from 'src/graphql/queries/GetSmCourse';
import { ContentfulLearningPath } from 'src/graphql/queries/GetLearningPath';
import {
  calculateCourseCompletionRate,
  calculateLearningPathCompletionRate,
} from 'src/store/progress/utils/progressUtils';
import {
  fetchProgressForLessons,
  completeSection,
  startLesson,
} from 'src/store/progress/actions/lessonProgressActions';
import { ProgressForCourses, ProgressForLessons } from 'src/services/http/progress';
import { fetchQuizProgress, completeLesson } from 'src/store/progress/actions/quizActions';

export interface ProgressState {
  progressForLessons: ProgressForLessons | undefined;
  progressForCourses: ProgressForCourses | undefined;
  isLoadingProgressForCourses: boolean;
}

const name = 'progress';

export const initialState: ProgressState = {
  progressForLessons: undefined,
  progressForCourses: undefined,
  isLoadingProgressForCourses: false,
};

export const actions = {
  fetchProgressForLessons,
  fetchProgressForCourses,
  completeSection,
  fetchQuizProgress,
  completeLesson,
  startLesson,
};

export type Actions = typeof actions;

export const progressStore = createStore<ProgressState, Actions>({
  name,
  initialState,
  actions,
});

export const useProgressState = createHook(progressStore);

// Selectors
const selectCourseCompletionRate = (state: ProgressState, course: ContentfulSmCourse | undefined): number =>
  calculateCourseCompletionRate(state.progressForLessons, course);

const selectLearningPathCompletionRate = (
  state: ProgressState,
  learningPath: ContentfulLearningPath | undefined,
): number => calculateLearningPathCompletionRate(state.progressForCourses, learningPath);

// Hooks
export const useLearningPathCompletionRate = createHook(progressStore, {
  selector: selectLearningPathCompletionRate,
});

export const useCourseCompletionRate = createHook(progressStore, {
  selector: selectCourseCompletionRate,
});
